define('gameday-device-interaction/lib/default',['require','exports','module','./DeviceInteraction'],function(require,exports,module){
    var DeviceInteraction = require( "./DeviceInteraction" );

    function DefaultInteraction(){}

    DefaultInteraction.isDispatcherAvailable = true;

    DeviceInteraction.spawn(DefaultInteraction)
        .define({
            type    : "default",
        });
    return DefaultInteraction;
});
